export default "__VITE_ASSET__ZK8GNiUY__"